import { Button, Spin, Typography, Modal } from "antd";
import Dragger from "antd/es/upload/Dragger";
import {
  DeleteOutlined,
  InboxOutlined,
  LoadingOutlined,
  PaperClipOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { useState } from "react";

import { getFileUrl } from "../../../../utils";
import { UploadFileModuleProps } from "../../../../models";

const UploadFileModal = ({
  id,
  isVisible,
  isLoading,
  handleClose,
  addCertifiedOrder,
}: UploadFileModuleProps) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileSelect = (info: any) => {
    setSelectedFile(info?.file || null);
  };

  const handleAddCertifiedOrder = () => {
    if (!selectedFile || !id) {
      return;
    }

    addCertifiedOrder(id, selectedFile, handleClose);
    setSelectedFile(null);
  };

  return (
    <Modal
      open={isVisible}
      onCancel={handleClose}
      footer={null}
      centered
      width={600}
    >
      <div className="flex flex-col items-center">
        <Typography className="text-center font-bold my-6">
          SLANJE OVJERENOG NALOGA
        </Typography>
        {!isLoading ? (
          <Dragger
            multiple={false}
            maxCount={1}
            customRequest={handleFileSelect}
            showUploadList={false}
            className="w-3/4"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined className="text-primary" />
            </p>
            <p className="ant-upload-text">Kliknite ovdje da bi dodali fajl</p>
            <p className="ant-upload-hint">
              Dodajte skeniran, potpisan i ovjeren nalog
            </p>
          </Dragger>
        ) : (
          <div className="h-[150px] text-center py-10">
            <Spin indicator={<LoadingOutlined spin />} />
            <Typography className="font-semibold mt-6">
              Dodaje se dokument...
            </Typography>
          </div>
        )}
        {selectedFile && (
          <div className="flex w-3/4 mt-6 bg-light-gray">
            <PaperClipOutlined className="text-black opacity-45 ml-2" />
            <div className="flex justify-between items-center w-full">
              <a
                className="ml-2 text-primary"
                href={getFileUrl(selectedFile)}
                download={selectedFile.name}
              >
                {selectedFile.name}
              </a>
              <Button
                type="text"
                onClick={() => handleFileSelect(null)}
                icon={<DeleteOutlined className="text-black opacity-45" />}
                className="border-none"
              />
            </div>
          </div>
        )}
        <Button
          onClick={handleAddCertifiedOrder}
          className="mt-6 text-sm text-white bg-primary font-medium rounded-sm border-primary shadow-sm flex justify-center items-center py-2"
          icon={<SendOutlined />}
        >
          POŠALJI
        </Button>
      </div>
    </Modal>
  );
};

export default UploadFileModal;
